import React, { useEffect } from "react";
import cn from "classnames";
import { useParams } from "react-router-dom";

import { ReactComponent as Refresh } from "../../../assets/images/refresh.svg";

import css from "../AppHeader.module.css";

interface ComponentProps {
    setActiveEnvironmentById: (id: string) => void;
    setRefreshActivated: (isRefreshActivated: boolean) => void;
}

const RefreshButton: React.FC<ComponentProps> = ({
    setActiveEnvironmentById,
    setRefreshActivated,
}: ComponentProps) => {
    const { environmentId } = useParams<{ environmentId: string }>();

    useEffect(() => {
        if (environmentId) {
            setActiveEnvironmentById(environmentId);
        }
    }, [environmentId, setActiveEnvironmentById]);

    return (
        <div
            className={cn(css.btn, css.btnRefresh)}
            onClick={() => setRefreshActivated(true)}
        >
            <Refresh />
        </div>
    );
};

export default RefreshButton;
